<template>
  <div>
    <search :show.sync="showFilterPop" @handlequery="handleFqueryFilter" :type="!isScrm" />
    <van-cell style="padding: 16px 10px;">
      <van-tag size="large" type='primary' @click="clickTag(item.dayType)" v-for="(item,index) in timeOptions" :key="index" color="#F4F5F7"
        text-color="#606060" :class="activeId === item.dayType?'tag-click':'tag-before'">{{item.value}}</van-tag>
      <van-icon style="margin-left: 10px" size="20" name="filter-o" @click="handleFilter()" />
    </van-cell>
    <div class="Statistics_title">{{isScrm?'部门客户数':'部门合同数据统计'}}</div>
    <!-- <div class="vant-table">
      <table cellspacing="0" style="width:100%" class="table">
        <tr>
          <th class="th" v-for="(item, index) in option.column" :key="index">{{ item.label }}</th>
        </tr>
        <tr v-for="(item, index) in tableData" :key="index" class="list-tr">
          <td v-for="(context, i) in option.column" :key="i">{{ item[context.tableDataprop] }}</td>
        </tr>
      </table>
    </div> -->
    <tongji-table :tableData="tableData" :option="option" />

  </div>
</template>

<script>
import {
  Grid,
  GridItem
  // Image as VanImage
  // Cascader
} from 'vant'
import search from './component/search.vue'
// import { getAllStage } from '@/api/scrm/mycust'
// import { getDicts } from '@/api/system/dict/data'
import statistics from '@/api/tongji/statistics'
// import { CascaderTreeSelect } from '@/api/admi/dept'
import tongjiTable from './component/tongjiTable.vue'
// import { listStatistical } from '@/api/tongji/index'
export default {
  name: 'TongjiIndex',
  components: {
    search,
    tongjiTable,
    [Grid.name]: Grid,
    // [VanImage.name]: VanImage,
    [GridItem.name]: GridItem
    // vanCascader: Cascader
  },
  props: {},
  data() {
    return {
      isScrm: null,
      showFilterPop: false,
      // activeNames: ['1'],
      // icon_title: require('../../assets/images/tj/ghicon.png'),
      activeId: '1',
      queryParams: {
        deptId: null,
        startTime: null,
        endTime: null,
        dayType: null
      },
      divisionList: [],
      boSuccessList: [],
      boList: [],
      notBoList: [],
      custList: [],
      businessFunnel: [],
      options: {
        boStageIdOptions: []
      },
      arr: [],
      tableData: [],
      // th
      option: {
        column: []
      },
      // // 合同类型
      // contractTypeOptions: this.$store.state.dictOptions.contractType || [],
      // // 合同状态
      // contractStatusOptions: this.$store.state.dictOptions.contractStatus || [],
      // // 产品类型列表
      // businessTypeOptions: this.$store.state.dictOptions.businessTypeTree || [],
      timeOptions: [{ dayType: '1', value: '昨天' }, { dayType: '0', value: '今天' }, { dayType: '30', value: '本月' }, { dayType: '180', value: '上半年' }, { dayType: '365', value: '今年' }, { dayType: this.getPreMonth(), value: this.getPreMonth() + '年' }]
    }
  },
  computed: {},
  watch: {},
  async created() {
    const query = JSON.parse(this.$route.query.queryParams)
    this.activeId = query.dayType
    this.queryParams = { ...this.queryParams, ...query }
    if (this.$route.query.type === 'scrm') {
      this.isScrm = true
      this.option.column = [{
        label: '部门/人',
        tableDataprop: 'deptName'
      },
      {
        label: '客户数',
        tableDataprop: 'khs'
      },
      {
        label: '商机数',
        tableDataprop: 'sjs'
      },
      {
        label: '无商机客户',
        tableDataprop: 'wsjkh'
      },
      {
        label: '成交数',
        tableDataprop: 'cjs'
      }]
      await this.getStatisticsByDept()
      this.setTableData()
    } else if (this.$route.query.type === 'contract') {
      this.isScrm = false
      this.option.column = [{
        label: '部门/人',
        tableDataprop: 'deptName'
      },
      {
        label: '合同数',
        tableDataprop: 'hts'
      },
      {
        label: '单次合同数',
        tableDataprop: 'dchts'
      },
      {
        label: '框架合同数',
        tableDataprop: 'kjhts'
      },
      {
        label: '单次合同金额',
        tableDataprop: 'dchtje'
      }]
      await this.getConStatisticsByDept()
      this.setTableData2()
    }
    console.log(this.option)
  },
  async mounted() {
    this.init()
  },
  methods: {
    async init() {
      // 修改主体框架标题
      document.title = 'scrm-统计'
    },
    /** 获取上一年 */
    getPreMonth() {
      var date = new Date()
      var year = date.getFullYear()
      return parseInt(year) - 1
    },
    // scrm获取不同部门统计数据
    async getStatisticsByDept() {
      await statistics.getCustCountByDept(this.queryParams).then(res => {
        if (res.code === 200) {
          this.custList = res.rows
          const arr = res.rows
          this.arr = []
          arr.forEach(item => {
            if (item.nickName) {
              this.arr.push({ deptName: item.nickName, userId: item.userId })
            } else {
              this.arr.push({ deptName: item.deptName.replace('事业部', ''), deptId: item.deptId })
            }
          })
        }
      })
      await statistics.getBoSuccessCountByDept(this.queryParams).then(res => {
        if (res.code === 200) {
          this.boSuccessList = res.rows
        }
      })
      await statistics.getBoCountByDept(this.queryParams).then(res => {
        if (res.code === 200) {
          this.boList = res.rows
        }
      })
      await statistics.getNotBoCountByDept(this.queryParams).then(res => {
        if (res.code === 200) {
          this.notBoList = res.rows
        }
      })
    },
    // 设置tableData
    setTableData() {
      this.arr.map(item => {
        if (item.deptId) {
          item.khs = this.custList.find(i => i.deptId === item.deptId).order
          item.sjs = this.boList.find(i => i.deptId === item.deptId).order
          item.wsjkh = this.notBoList.find(i => i.deptId === item.deptId).order
          item.cjs = this.boSuccessList.find(i => i.deptId === item.deptId).order
        } else {
          item.khs = this.custList.find(i => i.userId === item.userId).order
          item.sjs = this.boList.find(i => i.userId === item.userId).order
          item.wsjkh = this.notBoList.find(i => i.userId === item.userId).order
          item.cjs = this.boSuccessList.find(i => i.userId === item.userId).order
        }
      })
      const zkhs = this.custList.reduce((total, item) => total + item.order, 0)
      const zsjs = this.boList.reduce((total, item) => total + item.order, 0)
      const zwsjkh = this.notBoList.reduce((total, item) => total + item.order, 0)
      const zcjs = this.boSuccessList.reduce((total, item) => total + item.order, 0)
      this.arr.push({ deptName: '合计', khs: zkhs, sjs: zsjs, wsjkh: zwsjkh, cjs: zcjs })
      this.tableData = this.arr
    },
    // contract获取不同部门统计数据
    async getConStatisticsByDept() {
      await statistics.getContractCountByDept(this.queryParams).then(res => {
        if (res.code === 200) {
          this.contractList = res.rows
          const arr = res.rows
          this.arr = []
          arr.forEach(item => {
            if (item.nickName) {
              this.arr.push({ deptName: item.nickName, userId: item.userId, hts: item.order })
            } else {
              this.arr.push({ deptName: item.deptName.replace('事业部', ''), deptId: item.deptId, hts: item.order })
            }
          })
        }
      })
      await statistics.getContractCountByDept({ ...this.queryParams, frameType: 1 }).then(res => {
        if (res.code === 200) {
          this.contractDcList = res.rows
        }
      })
      await statistics.getContractCountByDept({ ...this.queryParams, frameType: 2 }).then(res => {
        if (res.code === 200) {
          this.contractKjList = res.rows
        }
      })
    },
    // 设置tableData
    setTableData2() {
      this.arr.map(item => {
        if (item.deptId) {
          item.dchts = this.contractDcList.find(i => i.deptId === item.deptId).order
          item.dchtje = this.contractDcList.find(i => i.deptId === item.deptId).money
          item.kjhts = this.contractKjList.find(i => i.deptId === item.deptId).order
        } else {
          item.dchts = this.contractDcList.find(i => i.userId === item.userId).order
          item.dchtje = this.contractDcList.find(i => i.userId === item.userId).money
          item.kjhts = this.contractKjList.find(i => i.userId === item.userId).order
        }
      })
      const zhts = this.contractList.reduce((total, item) => total + item.order, 0)
      const zdchts = this.contractDcList.reduce((total, item) => total + item.order, 0)
      const zdchtje = this.contractDcList.reduce((total, item) => total + item.money, 0)
      const zkjhts = this.contractKjList.reduce((total, item) => total + item.order, 0)
      this.arr.push({ deptName: '合计', hts: zhts, dchts: zdchts, dchtje: zdchtje, kjhts: zkjhts })
      this.tableData = this.arr
    },
    // 接收子组件的filter事件
    handleFilter() {
      this.showFilterPop = true
    },
    // 过滤子组件传递过来的搜索对象
    async handleFqueryFilter(data) {
      this.showFilterPop = false
      const query = this.queryParams
      this.queryParams = { ...query, ...data }
      if (this.queryParams.startTime || this.queryParams.endTime) {
        this.activeId = null
      } else {
        this.activeId = '1'
      }
      if (this.$route.query.type === 'scrm') {
        await this.getStatisticsByDept()
        this.setTableData()
      } else if (this.$route.query.type === 'contract') {
        await this.getConStatisticsByDept()
        this.setTableData2()
      }
    },
    async clickTag(id) {
      this.activeId = id
      this.queryParams.dayType = id
      this.queryParams.startTime = null
      this.queryParams.endTime = null
      if (this.$route.query.type === 'scrm') {
        await this.getStatisticsByDept()
        this.setTableData()
      } else if (this.$route.query.type === 'contract') {
        await this.getConStatisticsByDept()
        this.setTableData2()
      }
    }
  }
}
</script>

<style scoped lang='less'>
@import url("@/style/index.less");
// *{touch-action: none;}
.van-cell {
  touch-action: none;
}

/deep/.van-cell__value{
  display: flex;
  align-items: center;
  justify-content: space-between;
  // padding: 20px 0px;
}
.tag-click{
  border: 0.02667rem solid #1E90FF !important;
  color:#fff !important;
  background-color: #1E90FF !important;
}
.tag-before{
  border: 0.02667rem solid #999999 !important;
  background-color: #fff !important;
}
.Statistics_title{
  margin-top: 15px;
  background-color: #fff;
  padding: 10px 0;
  font-size: 28px;
  color:#87CEFA;
  text-align: center;
}
.vant-table{
  margin-top: 15px;
  background-color: #fff;
  padding: 20px;
  padding-bottom: 120px;
  .table {
    border: 2px solid #ddd;
    line-height: 65px;
    font-size: 28px;
    text-align: center;
    color: #666;
    .th {
      // height: 1.074074rem;
      // line-height: 60px;
      // font-size: 30px;
      // text-align: center;
      font-weight: 400;
      border-right: 2px solid #ddd;
    }
    .th:last-child {
      border-right: none;
    }
    .list-tr:hover {
      background-color: #f5f5f5;
    }
    // .list-tr:nth-child(2n) {
    //   background-color: #f6f6f6;
    // }
    td {
      border-top: 2px solid #ddd;
      border-right: 2px solid #ddd;
    }
    td:last-child {
      border-right: none;
    }
  }
}

</style>
